module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menuHeaderAdmin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "linksWrapper mobileNot col-lg-10 col-md-10"
  }, [(_vm.hasAccessCreate('product_manager')) ? _c('router-link', {
    staticClass: "menu-admin",
    attrs: {
      "to": "/admin/components/new",
      "tag": "div"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("headerAdmin.cpnt_management")))])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessDiamAdmin()) ? _c('router-link', {
    staticClass: "menu-admin",
    attrs: {
      "to": "/displayers",
      "tag": "div"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("headerAdmin.displayers")))])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessBothAdmin()) ? _c('router-link', {
    staticClass: "menu-admin",
    attrs: {
      "to": "/admin/uploader",
      "tag": "div"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("headerAdmin.uploadPage")))])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessDiamAdmin()) ? _c('router-link', {
    staticClass: "menu-admin",
    attrs: {
      "to": "/standDesign-list",
      "tag": "div"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("headerAdmin.design")))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "adminLeftSide col-lg-2 col-md-2"
  }, [_c('div', {
    staticClass: "user-connect"
  }, [(!_vm.hasAccessSuperAdmin() && !_vm.hasAccessDiamAdmin()) ? _c('div', {
    staticClass: "admin uppercase"
  }, [_vm._v(_vm._s(_vm.getBrand.name + " admin"))]) : (!_vm.hasAccessSuperAdmin() && _vm.hasAccessDiamAdmin()) ? _c('div', {
    staticClass: "admin uppercase"
  }, [_vm._v(_vm._s("REM3RCH admin"))]) : (_vm.hasAccessSuperAdmin()) ? _c('div', {
    staticClass: "admin uppercase"
  }, [_vm._v(_vm._s(_vm.$t("headerAdmin.super_admin")))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dab896c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderAdmin.vue
// module id = 3252
// module chunks = 0